import { render, staticRenderFns } from "./NewQuoteRules.vue?vue&type=template&id=f76aa354"
import script from "./NewQuoteRules.vue?vue&type=script&lang=js"
export * from "./NewQuoteRules.vue?vue&type=script&lang=js"
import style0 from "./NewQuoteRules.vue?vue&type=style&index=0&id=f76aa354&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wedevs/Herd/dokan-core/wp-content/plugins/dokan-pro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f76aa354')) {
      api.createRecord('f76aa354', component.options)
    } else {
      api.reload('f76aa354', component.options)
    }
    module.hot.accept("./NewQuoteRules.vue?vue&type=template&id=f76aa354", function () {
      api.rerender('f76aa354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "modules/request-for-quotation/assets/src/js/admin/pages/NewQuoteRules.vue"
export default component.exports